module.exports = __webpack_public_path__ + "img/multilingualism@2x.262d26b.jpg";